/**
 * Shape check for the Client Workspace reply-to address, run before the settings are sent.
 *
 * This mirrors the rules the workspace's admin API enforces on PATCH /firm
 * (portal/backend/src/internal/adminRouter.ts) and must stay in step with them: a check
 * stricter than the server's blocks a value the server would take, and a looser one lets
 * a typo through to a round trip that is rejected anyway. The server remains the
 * authority — this only saves the admin that round trip.
 *
 * The field is optional; a blank value clears the setting and is always valid.
 */

// A hostname of at least two labels ending in an alphabetic TLD, e.g. acme.com.
const DOMAIN_RE = /^([a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/i;
const LOCAL_PART_RE = /^[^\s@<>()[\]\\,;:"]{1,64}$/;

export const isValidDomain = (value: string): boolean => value.length <= 253 && DOMAIN_RE.test(value);

export const isValidEmail = (value: string): boolean => {
	const at = value.lastIndexOf('@');
	return at > 0 && value.length <= 320 && LOCAL_PART_RE.test(value.slice(0, at)) && isValidDomain(value.slice(at + 1));
};

/** Reply-to address: blank, or a single email address. */
export const isValidReplyTo = (value: string): boolean => value === '' || isValidEmail(value);
